import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './layouts/Index';
import Dashboard from './layouts/Dashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class App extends Component {
    componentDidMount() {
        // Tawk.to chat disabled — legacy property ID throws in their embed script.
        // Re-enable by calling this.func() with a fresh property ID.
    }
    func = () => {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0]
        s1.async = true;
        s1.src = 'https://embed.tawk.to/605b8c40067c2605c0bbea8a/1f1ipnnm8';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        // s1.setAttribute("Access-Control-Allow-Origin", "*");
        // s1.setAttribute("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");
        s0.parentNode.insertBefore(s1, s0);
    }
    render() {
        return (
            <BrowserRouter>
                <div>

                    <Routes>
                        <Route path='/dashboard/*' element={<Dashboard />} />
                        <Route path='/*' element={<Index />} />
                    </Routes>
                    <ToastContainer />
                </div>
            </BrowserRouter>
        );
    }
}


